import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import * as styled from './styles';

function QuickFacts({
  heading,
  colorTheme,
  tags,
}) {
  const tagList = tags.map((tag, i) => tag.text.split(', '));
  const containerRef = useRef();

  const updateLineEndTags = () => {
    const tags = containerRef.current.querySelectorAll('.tag');
    let lastTop = null;

    tags.forEach(tag => tag.classList.remove('is-last-in-line'));

    tags.forEach((tag, i) => {
      const top = tag.getBoundingClientRect().top;

      if (lastTop !== null && top > lastTop) {
        tags[i - 1]?.classList.add('is-last-in-line');
      }

      lastTop = top;
    });

    tags[tags.length - 1]?.classList.add('is-last-in-line');
  };

  useEffect(() => {
    updateLineEndTags();
    window.addEventListener('resize', updateLineEndTags);

    return () => window.removeEventListener('resize', updateLineEndTags);
  }, [tags]);


  return (
    <styled.Wrapper colorTheme={colorTheme}>
      <styled.Inner colorTheme={colorTheme}>
        <styled.Content>
          <styled.Heading level={200} colorTheme={colorTheme}>{heading}</styled.Heading>
          <styled.Tags itemscope itemtype={'https://schema.org/CreativeWork'}>
            <meta itemProp="keywords" content={tagList} />
            <div ref={containerRef}>{tags.map((tag, i) => (
              <>
                <styled.Tag key={i} {...tag} className="tag">{tag.text}</styled.Tag>
              </>
            ))}
            </div>
          </styled.Tags>
        </styled.Content>
      </styled.Inner>
    </styled.Wrapper>
  );
}

QuickFacts.propTypes = {
  tags: PropTypes.shape({
    text: PropTypes.string.isRequired,
    bold: PropTypes.bool,
  }).isRequired,
  heading: PropTypes.string.isRequired,
  colorTheme: PropTypes.oneOf(['dark-blue', 'green', 'orange', 'dark-purple', 'white']),
};

QuickFacts.defaultProps = {
  colorTheme: 'dark-blue',
};

export default QuickFacts;
